<template>
  <div class="flex justify-center items-center">
    <div class="w-full max-w-lg">
      <form @submit.prevent="submit">
        <div class="px-10 pb-12">
          <h1 class="text-center font-bold text-3xl uppercase">Înregistrare</h1>
          <div class="mx-auto mt-6 w-24 border-b-2"/>
          <text-input v-model="form.firstName" :required="true" :errors="$page.errors.first_name" class="mt-10"
                      label="Prenume" type="text" autofocus autocapitalize="on"/>
          <text-input v-model="form.lastName" :required="true" :errors="$page.errors.last_name" class="mt-10"
                      label="Nume" type="text" autofocus autocapitalize="on"/>
          <text-input v-model="form.email" :required="true" :errors="$page.errors.email" class="mt-10" label="Email"
                      type="email" autocapitalize="off"/>
          <text-input v-model="form.password" :required="true" :errors="$page.errors.password" class="mt-6"
                      label="Parolă" type="password"/>
          <text-input v-model="form.confirmPassword" :required="true" class="mt-6" label="Confirmare parolă"
                      type="password"/>
          <!-- Additional fields if needed -->
        </div>
        <div class="px-10 py-4 bg-grey-100 border-grey-200 flex justify-end items-center">
          <!-- Hidden field to store the reCAPTCHA token -->
          <input type="hidden" name="recaptcha_token" id="recaptcha_token" />
          <loading-button :loading="sending" class="btn-gray" type="submit">Înregistrare</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'

export default {
  metaInfo() {
    return {
      title: 'Înregistrare',
      meta: [
        { name: 'robots', content: 'noindex, nofollow, nosnippet, noarchive' },
        { name: 'googlebot', content: 'noindex, nofollow, nosnippet, noarchive' }
      ]
    }
  },
  layout: Layout,
  components: {
    LoadingButton,
    Logo,
    TextInput,
    Layout
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      sending: false,
      form: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        confirmPassword: null,
        // terms: null,
        // gdpr: null
      },
    }
  },
  methods: {
    submit() {
      const siteKey = process.env.MIX_RECAPTCHA_SITE_KEY;
      this.sending = true;
      // Ensure reCAPTCHA is loaded
      if (typeof grecaptcha !== 'undefined') {
        // Execute reCAPTCHA v3 using your site key and an action (e.g., 'register')
        grecaptcha.execute(siteKey, { action: 'register' })
            .then((token) => {
              // Set the token in the hidden input (if needed)
              document.getElementById('recaptcha_token').value = token;
              // Submit the form data along with the recaptcha token
              this.$inertia.post(this.route('shop.register'), {
                first_name: this.form.firstName,
                last_name: this.form.lastName,
                email: this.form.email,
                password: this.form.password,
                password_confirmation: this.form.confirmPassword,
                recaptcha_token: token,
                // terms: this.form.terms,
                // gdpr: this.form.gdpr,
              }).then(() => {
                this.sending = false;
              }).catch(() => {
                this.sending = false;
              });
            })
            .catch((error) => {
              console.error('reCAPTCHA error:', error);
              this.sending = false;
            });
      } else {
        console.error('reCAPTCHA is not loaded.');
        this.sending = false;
      }
    },
  },
}
</script>
